<template>
  <div>
    <!-- Modal Component -->
    <div id="restaurantCustomerModal" class="modal fade" tabindex="-1" role="dialog" 
         aria-labelledby="restaurantCustomerModal" aria-hidden="true">
      <div class="modal-dialog" role="document" style="max-width: 50%;">
        <div class="modal-content">
          <div class="modal-header text-white">
            <h5 class="modal-title">RESTAURANT CUSTOMER</h5>
            <!-- <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" @click="closeModal">
              <span aria-hidden="true">&times;</span>
            </button> -->
          </div>
          <div class="modal-body">
            <!-- Floor Selection Field (NEW) -->
            <div class="form-group row align-items-center mb-4">
              <label for="floorId" class="col-sm-4 col-form-label">Select Floor</label>
              <div class="col-sm-8">
                <select class="form-control" id="floorId" v-model="selectedFloor" :disabled="loading">
                  <option value="">-- Select Floor --</option>
                  <option v-for="floor in floors" :key="floor.id" :value="floor">
                    {{ floor.floor }}
                  </option>
                </select>
                <small v-if="loading" class="text-muted">Loading floors...</small>
              </div>
            </div>
            
            <!-- Table Number Field -->
            <div class="form-group row align-items-center mb-4">
              <label for="tableNumber" class="col-sm-4 col-form-label">Table Number</label>
              <div class="col-sm-8 input-group">
                <input type="text" class="form-control" id="tableNumber" 
                       v-model="form.tableNumber" ref="tableNumberInput">
                <div class="input-group-append">
                  <button class="btn btn-outline-secondary" type="button" 
                          @click="openNumericKeypad('tableNumber')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
                  class="bi bi-calculator" viewBox="0 0 16 16">
                <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/>
                <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"/>
              </svg>
                  </button>
                </div>
              </div>
            </div>
            
            <!-- Number of Customers Field -->
            <div class="form-group row align-items-center mb-4">
              <label for="customerCount" class="col-sm-4 col-form-label">No. of Customers</label>
              <div class="col-sm-8 input-group">
                <input type="text" class="form-control" id="customerCount" 
                       v-model="form.customerCount" ref="customerCountInput">
                <div class="input-group-append">
                 <button class="btn btn-outline-secondary" type="button" 
                    @click="openNumericKeypad('customerCount')">
              <!-- Calculator icon (more appropriate for numeric input) -->
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" 
                  class="bi bi-calculator" viewBox="0 0 16 16">
                <path d="M12 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h8zM4 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H4z"/>
                <path d="M4 2.5a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-2zm0 4a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm3-6a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-4z"/>
              </svg>
            </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
            <button type="button" class="btn btn-primary" @click="submitForm">Submit</button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Numeric Keypad Component -->
    <!-- <NumericKeypad ref="numericKeypad" @input="handleKeypadInput" @close="closeKeypad" /> -->
    <NumericKeypad 
  ref="numericKeypad" 
  @input="handleKeypadInput"  
  @close="closeKeypad" 
/>
  </div>
</template>

<script>
import NumericKeypad from './NumericKeypad.vue';
import $ from 'jquery';

export default {
  name: 'RestaurantCustomerModal',
  components: {
    NumericKeypad
  },
  props: {
    branchId: {
      type: [Number, String],
      default: null
    }
  },
  data() {
    return {
      form: {
        tableNumber: "",
        customerCount: ""
      },
      selectedFloor: null, // Changed from floorId to selectedFloor object
      floors: [],
      loading: false,
      currentInput: null
    };
  },
  mounted() {
    $('#restaurantCustomerModal').modal({
      backdrop: 'static',
      keyboard: false,
      show: true
    });
    $('#restaurantCustomerModal').on('hidden.bs.modal', () => {
      this.$emit('close');
    });
    
    // Fetch floors when modal is mounted
    this.fetchFloors();
  },
  beforeUnmount() {
    $('#restaurantCustomerModal').off('hidden.bs.modal');
    $('#restaurantCustomerModal').modal('hide');
  },
  methods: {
    async fetchFloors() {
      try {
        this.loading = true;
        const token = localStorage.getItem('authToken');
        const appId = localStorage.getItem('appId') || 1;
        
        // Build URL based on whether branchId is provided
        let url = `${this.$BASE_API_URL}/api/floors?appId=${appId}`;
        if (this.branchId) {
          url = `${this.$BASE_API_URL}/api/floors/by-branch/${this.branchId}?appId=${appId}`;
        }
        
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch floors');
        }

        const data = await response.json();
        this.floors = data.data || [];
      } catch (error) {
        console.error('Error fetching floors:', error);
        // You can add a toast notification here if available
        // this.$toast?.error('Failed to load floors');
      } finally {
        this.loading = false;
      }
    },
    show() {
      $('#restaurantCustomerModal').modal('show');
      // Refresh floors when showing modal
      this.fetchFloors();
    },
    resetForm() {
      this.form = {
        tableNumber: "",
        customerCount: ""
      };
      this.selectedFloor = null;
    },
    openNumericKeypad(fieldName) {
      this.currentInput = fieldName;
      this.$refs.numericKeypad.inputValue = this.form[fieldName];
      this.$refs.numericKeypad.show();
    },
    handleKeypadInput(value) {
      if (this.currentInput) {
        this.form[this.currentInput] = value;
      }
    },
    closeKeypad() {
      this.$refs.numericKeypad.hide();
    },
    closeModal() {
      $('#restaurantCustomerModal').modal('hide');
    },
    submitForm() {
      // Prepare submit data with floor name instead of floor ID
      const submitData = {
        tableNumber: this.form.tableNumber,
        customerCount: this.form.customerCount,
        floorId: this.selectedFloor ? this.selectedFloor.id : null,
        floorName: this.selectedFloor ? this.selectedFloor.floor : null, 
        floor: this.selectedFloor 
      };
      
      this.$emit('submit', submitData);
      this.closeModal();
    }
  }
};
</script>
<style>
.modal-header{
     width: -webkit-fill-available;
    justify-content: center;
}

.modal-header {
  background-color: #4caf50;
  color: white;
}

.form-control:focus {
  border-color: #4caf50;
  box-shadow: 0 0 0 0.2rem rgba(76, 175, 80, 0.25);
}

.btn-primary {
  background-color: #4caf50;
  border-color: #4caf50;
}

.btn-primary:hover {
  background-color: #45a049;
  border-color: #45a049;
}

select.form-control {
  cursor: pointer;
}

select.form-control:disabled {
  background-color: #e9ecef;
  cursor: not-allowed;
}
</style>